// import React from "react";
// import { Line } from "react-chartjs-2";

// const CountByDayReport = ({
//   chartData,
//   chartOptions,
//   storess,
//   range,
//   chartRef,
//   containerId,
// }) => {
//   const startDate = range?.tran_date?.$lte?.split("T")[0] || "";
//   const endDate = range?.tran_date?.$gte?.split("T")[0] || "";

//   return (
//     <div ref={chartRef} id={containerId}>
//       <div className="card">
//         <Line data={chartData} options={chartOptions} />
//       </div>

//       <div className="print-only-content">
//         <h2>Report Details</h2>
//         <div className="d-flex justify-content-between align-items-center print-only-content">
//           <h3>Brand: Angels Pizza</h3>
//           <h4 className="mx-auto"></h4>
//           <h3>Store: {storess}</h3>
//           <h3>Date: {`${startDate} ${endDate}`}</h3>
//         </div>

//         <div style={{ fontSize: "20px" }}>
//           <table className="table text-center">
//             <thead>
//               <tr className="d-flex">
//                 <th>Day</th>
//                 <th className="ms-5">Count</th>
//               </tr>
//             </thead>
//             <tbody>
//               {chartData.labels.map((label, index) => (
//                 <tr className="d-flex" key={`${containerId}-${label}`}>
//                   <td>{label}</td>
//                   <td>{chartData.datasets[0].data[index]}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CountByDayReport;

import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const CountByDayReport = ({
  chartData,
  chartOptions, // not required if you’ll build options inside
  storess,
  range,
  chartRef,
  containerId,
}) => {
  // FIX: you swapped gte/lte before. Usually gte=start, lte=end.
  const startDate = range?.tran_date?.$gte?.split("T")[0] || "";
  const endDate = range?.tran_date?.$lte?.split("T")[0] || "";

  // Convert ChartJS data => Highcharts series
  const categories = chartData?.labels || [];
  const datasets = chartData?.datasets || [];

  const series = datasets.map((ds) => ({
    name: ds.label,
    data: (ds.data || []).map((v) => Number(v ?? 0)),
    // optional: respect your colors
    color: ds.borderColor || ds.backgroundColor,
  }));

  const options = {
    chart: {
      type: "area", // stacked area (closest to fill:true in ChartJS)
      height: 380,
    },
    title: {
      text: "Total Transactions vs Day of Week",
    },
    subtitle: {
      text: storess ? `Store: ${storess}` : "All Stores",
    },
    xAxis: {
      categories,
      title: { text: null },
    },
    yAxis: {
      title: { text: "Transactions" },
      allowDecimals: false,
    },
    legend: {
      align: "center",
      verticalAlign: "top",
    },
    tooltip: {
      shared: true,
      valueDecimals: 0,
    },
    plotOptions: {
      area: {
        stacking: "normal", // stacked like your ChartJS stacked config
        marker: { enabled: false },
      },
      series: {
        animation: false,
      },
    },
    credits: { enabled: false },
    series,
  };

  return (
    <div ref={chartRef} id={containerId}>
      <div className="card">
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>

      <div className="print-only-content">
        <h2>Report Details</h2>
        <div className="d-flex justify-content-between align-items-center print-only-content">
          <h3>Brand: Angels Pizza</h3>
          <h4 className="mx-auto"></h4>
          <h3>Store: {storess || "All Stores"}</h3>
          <h3>Date: {`${startDate} - ${endDate}`}</h3>
        </div>

        <div style={{ fontSize: "20px" }}>
          <table className="table text-center">
            <thead>
              <tr className="d-flex">
                <th>Day</th>
                <th className="ms-5">Dine-in</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((label, index) => (
                <tr className="d-flex" key={`${containerId}-${label}`}>
                  <td>{label}</td>
                  <td>{datasets?.[0]?.data?.[index] ?? 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CountByDayReport;
